import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseNoticeListAttentionItem.module.scss'

import IconNew from '@Ui/images/myhouse/IconNew.svg'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  attentionList?: any
}

const MyhouseNoticeListAttentionItem: React.FC<Props> = ({ attentionList }: Props) => {
  const history = useHistory()

  const handleClick = (href: string) => (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()
    handleNclick(NCLICK.MY_HOUSE.NOTICE_LIST.DETAIL, evt)

    history.push(href)
  }

  return (
    <>
      {attentionList.map((item: any, index: any) => (
        <div key={`item_${index}`} className={cx('item')}>
          <a href="#" className={cx('link', item.visited && 'type_visited')} onClick={handleClick(item.href)}>
            {item.attentionText && <strong className={cx('label')}>{item.attentionText}</strong>}
            {item.recent && (
              <>
                <IconNew />
                <span className="blind">new</span>
              </>
            )}
            <em className={cx('text')}>{item.title}</em>
          </a>
        </div>
      ))}
    </>
  )
}

export default MyhouseNoticeListAttentionItem
